import React from 'react';
import { Box } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
export default function AnswerResult({ id, result }) {
  const message = result === true
    ? 'Correct.'
    : result === false
      ? 'Incorrect — review your answer and try again.'
      : result === 'empty'
        ? 'Enter an answer before checking.'
        : '';
  return <Box id={id} role="status" aria-live="polite" aria-atomic="true"
    sx={{ display: 'flex', alignItems: 'center', gap: 1, color: result === true ? 'success.main' : 'error.main', minHeight: '1.75em', mt: 0.75, fontWeight: message ? 700 : 400 }}>
    {message ? <>
      {result === true
        ? <CheckCircleOutlineIcon aria-hidden="true" fontSize="small" />
        : <ErrorOutlineIcon aria-hidden="true" fontSize="small" />}
      {message}
    </> : null}
  </Box>;
}
